import { CalculatorDescription } from '../../../lib/calculators/calculator-description';
import { CalculatorId } from '../../../lib/calculators/calculator-config';

export const anovaDescription: CalculatorDescription = {
  id: CalculatorId.ANOVA,
  title: 'ANOVA Calculator',
  metaTitle: 'Online ANOVA Calculator - Analysis of Variance Tool',
  description: 'Perform one-way Analysis of Variance (ANOVA) to compare means across multiple groups. Test for significant differences between group means with statistical visualization.',
  metaDescription: 'Calculate ANOVA online. Compare means across multiple groups with our free Analysis of Variance calculator. Statistical hypothesis testing made easy.',
  howTo: {
    title: 'How to Use ANOVA Calculator',
    steps: [
      'Enter data for each group (one value per line)',
      'Add or remove groups as needed',
      'View the calculated F-statistic and p-value',
      'Interpret the results with visual aids',
      'Export or share your analysis'
    ]
  },
  examples: [
    {
      title: 'Crop Yield Study',
      description: 'Compare yields across different fertilizer treatments',
      dataDescription: 'Crop yields (in bushels/acre) for three different fertilizer treatments',
      insights: [
        'Treatment B shows the highest average yield at 57.8 bushels/acre',
        'The control group has the most consistent yields (smallest variance)',
        'There is a statistically significant difference between treatments (p < 0.05)',
        'Treatment B shows a 26% improvement over the control group'
      ]
    },
    {
      title: 'Student Test Scores',
      description: 'Compare performance across different teaching methods',
      dataDescription: 'Test scores (0-100) for students taught using three different methods',
      insights: [
        'The hybrid teaching method achieved the highest average score of 86.5',
        'All methods showed similar consistency in scores',
        'The hybrid method showed a significant improvement over traditional teaching',
        'Interactive and hybrid methods both outperformed traditional teaching'
      ]
    }
  ],
  relatedCalculators: [
    CalculatorId.BoxPlot,
    CalculatorId.Histogram,
    CalculatorId.BarGraph,
    CalculatorId.ScatterChart
  ]
}; 